<div
  #editorContainer
  class="editor-container"
  [class.read-only]="readOnly"
  style="width: 100%; height: 100%;">
</div>